import { h, Component } from "preact";
import { connect } from "preact-redux";
import PropTypes from "prop-types";
import { Loader, Menu, Header } from "semantic-ui-react";
import { DeviceGoogleLogout } from "./components/deviceGoogleLogout";

import styles from "./HappinessMenu.scss";
import { route } from "preact-router";
import {
  PATH_OVERVIEW,
  PATH_DIARY,
  PATH_MANAGERS,
  PATH_DASHBOARD,
} from "../../routes";
import userShape from "../../support/userShape";

import { getCurrentUserInfo } from "./actions";
import { ON_MOBILE_DEVICE } from "../../config";
import menuOptions from "./menuOptions";

class HappinessMenu extends Component {
  constructor(props) {
    super(props);

    if (!props.currentUser) {
      this.props.getCurrentUserInfo();
    }
  }

  render() {
    const { selectedPage, currentUser, componentsToRender } = this.props;
    if (!currentUser) {
      return (
        <div className={styles.menu}>
          <Loader active inline indeterminate>
            Loading user...
          </Loader>
        </div>
      );
    }
    return (
      <Menu
        attached={ON_MOBILE_DEVICE() ? "bottom" : "top"}
        tabular
        widths={ON_MOBILE_DEVICE() ? 5 : null}
        className={styles.menubar}
      >
        {ON_MOBILE_DEVICE() && (
          <Menu.Item
            link
            icon="chevron left"
            onClick={() => history.back()}
            title={"Go back"}
          />
        )}
        <Menu.Item
          link
          icon="pencil square"
          active={selectedPage == menuOptions.HAPPINESS_SUBMITTER}
          onClick={() => route(PATH_DIARY + "?transition=none")}
          title={"Add an entry to your Happiness Meter"}
        />
        <Menu.Item
          link
          icon="list"
          active={selectedPage == menuOptions.HAPPINESS_OVERVIEW}
          onClick={() => route(PATH_OVERVIEW + "?transition=none")}
          title={"View your past Happiness entries"}
        />
        {currentUser.is_manager && (
          <Menu.Item
            link
            icon="group"
            active={selectedPage == menuOptions.MANAGER_PAGE}
            onClick={() => route(PATH_MANAGERS + "?transition=none")}
            title={"See all users and managers"}
          />
        )}
        {currentUser.is_manager && (
          <Menu.Item
            link
            icon="table"
            active={selectedPage == menuOptions.DASHBOARD_PAGE}
            onClick={() => route(PATH_DASHBOARD + "?transition=none")}
            title={"View the user dashboard"}
          />
        )}
        {!ON_MOBILE_DEVICE() && (
          <Menu.Item>
            <Header>{this.props.headerText}</Header>
          </Menu.Item>
        )}
        {!ON_MOBILE_DEVICE() &&
          componentsToRender &&
          componentsToRender.map(component => {
            return <Menu.Item key="extraItem">{component}</Menu.Item>;
          })}
        {!ON_MOBILE_DEVICE() && (
          <Menu.Item position="right">
            <DeviceGoogleLogout />
          </Menu.Item>
        )}
      </Menu>
    );
  }
}

HappinessMenu.PropTypes = {
  currentUser: PropTypes.shape(userShape),
};

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = {
  getCurrentUserInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HappinessMenu);



// WEBPACK FOOTER //
// ./src/modules/menu/HappinessMenu.js